import { IFetchResponse, AppLog } from "@preveil-api";
import { BaseAPI, isValidJSON, StatusCode } from "src/common";
import _ from "lodash";

//------------------------------------------------------------------------------
// Description: Fetch App level Configurations from "/" as base_url
//------------------------------------------------------------------------------
export const getAppConfiguration = (): Promise<IFetchResponse> => {
    return BaseAPI.get("/config", null, {
        responseType: "json"
    })
        .then((response: IFetchResponse) => {
            // NOTE: Validate end point response before passing it back. Fall back to empty and the saga will default to .env variables
            const valid = isValidJSON(_.isString(response.data) ? response.data : JSON.stringify(response.data));
            return valid ? response : { ...response, isError: true, data: null };
        });
}

// Description: Log to app-server errors or for debugging
export const postAppLog = async (data: AppLog): Promise<IFetchResponse> => {
    return await BaseAPI.put(`/post/log`, data);
}

// Description: Validate passwords against service context words
export const getServicePasswordValidation = (): Promise<IFetchResponse> => {
    return BaseAPI.get("/validate_password", null, {
        responseType: "json"
    })
        .then((response: IFetchResponse) => {
            // NOTE: Validate end point response before passing it back. Fall back to empty and the saga will default to .env variables
            const valid = isValidJSON(_.isString(response.data) ? response.data : JSON.stringify(response.data));
            return valid ? response : { ...response, isError: true, data: null };
        });
}


// Description: Validate passwords against HIBP list of compromised passwords
// Reference: https://haveibeenpwned.com/Passwords
export const getHIBPValidationList = (prefix: string): Promise<IFetchResponse<string | null>> => {
    const headers = {
        "Add-Padding": "true" // Optional: adds padding for extra privacy
    };
    return BaseAPI.get(`https://api.pwnedpasswords.com/range/${prefix}`, null, headers)
        .then((response: IFetchResponse) => {
            return response.status === StatusCode.SUCCESS ?
                response : { ...response, isError: true, data: null };
        });
}
